const initialState = {
  message: '',
  response: ''
};

const chatbotReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'CHATBOT_REQUEST':
      return { ...state, message: action.payload, response: '' };
    case 'CHATBOT_SUCCESS':
      return { ...state, response: action.payload };
    default:
      return state;
  }
};

export default chatbotReducer;
